import { snackbar } from "@/core/controller/snackbar_controller";
import { headers } from "../const/headers";
import { codeDefault } from "../domain/code/code";

class CodeController {
  context = null;
  headers = headers
  loading = false
  search = ""
  dialog = false
  form = codeDefault()

  codePagination = {
    total: 0,
    items: []
  }

  options = {
    page: 1,
    itemsPerPage: 40,
    groupBy: [],
    sortBy: ["name"],
    groupDesc: [],
    multiSort: false,
    mustSort: false,
    sortDesc: []
  }

  constructor(
    context,
    fetchCodeUseCaseImpl,
    createCodeUseCaseImpl,
    changeCodeUseCaseImpl,
    deleteCodeUseCaseImpl
  ) {
    this.context = context;
    this.fetchCodeUseCaseImpl = fetchCodeUseCaseImpl
    this.createCodeUseCaseImpl = createCodeUseCaseImpl
    this.changeCodeUseCaseImpl = changeCodeUseCaseImpl
    this.deleteCodeUseCaseImpl = deleteCodeUseCaseImpl
  }

  async paginate() {
    this.loading = true
    try {
      this.codePagination = await this.fetchCodeUseCaseImpl(this.options, this.search)
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false
    }
  }

  open() {
    this.form = codeDefault()
  }

  close() {
    this.context.$refs.crud.resetValidation()
    this.dialog = false
  }

  async create() {
    if (this.context.$refs.crud.validate()) {
      try {
        this.loading = true
        if (this.form.id != 0) {
          await this.changeCodeUseCaseImpl(this.form.id, this.form)
          snackbar.show({ message: "Alterado com sucesso!!!", color: "#008000", timeout: 3000 })
        } else {
          await this.createCodeUseCaseImpl(this.form)
          snackbar.show({ message: "Adicionado com sucesso!!!", color: "#008000", timeout: 3000 })
        }
      } catch (error) {
        snackbar.show({ message: error.toString(), color: "#ff0000", timeout: 3000 })
      } finally {
        this.paginate()
        this.loading = false
        this.dialog = false
      }
    }
  }

  change(item) {
    this.dialog = true
    this.form = { ...item }
  }

  async delete(item) {
    try {
      const confirm = await snackbar.confirm({ message: "Deseja realmente excluir o registro?", color: "primary", timeout: 5000 })
      if (confirm) {
        await this.deleteCodeUseCaseImpl(item.id)
        this.paginate()
        snackbar.show({ message: "Resgistro excluído com sucesso!", color: "#008000", timeout: 1000 })
      }
    } catch (error) {
      snackbar.show({ message: error.toString() })
    }
  }


  watchOptions() {
    this.paginate()
  }

  watchSearch() {
    this.paginate()
  }


}

export default CodeController